import React, { FC } from "react";

import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { ProductFilterList } from "@src/components/MainApp/SharedProductPicker/filters/ProductFilterList";
import { ProductSearch } from "@src/components/MainApp/SharedProductPicker/filters/ProductSearch";

export const ProductFilters = ({
  allowIgProducts,
}: {
  allowIgProducts?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Grid padding={5} container direction={"column"} rowSpacing={5}>
      <Grid>
        <ProductSearch />
      </Grid>
      <Grid>
        <ProductFilterList allowIgProducts={allowIgProducts} />
      </Grid>
    </Grid>
  );
};
